<ion-row
  class="ion-justify-content-between ion-margin-horizontal"
  [ngClass]="{ 'ion-margin-bottom': !isShopsCarouselVisible }">
  @if (isShopsCarouselVisible) {
    <aaa-button
      size="medium"
      variant="on-map"
      class="drr-map-button"
      i18n-aria-label
      (click)="handleShowShopCards(false)"
      aria-label="Hide Cards">
      <aaa-icon size="small" color="dark" name="eye-off"></aaa-icon>
      <aaa-text size="subheadline" color="primary" i18n>Hide Cards</aaa-text>
    </aaa-button>
  } @else {
    <aaa-button
      size="medium"
      variant="on-map"
      class="drr-map-button"
      i18n-aria-label
      (click)="handleShowShopCards(true)"
      aria-label="Show Cards">
      <aaa-icon size="small" color="dark" name="eye"></aaa-icon>
      <aaa-text size="subheadline" color="primary" i18n>Show Cards</aaa-text>
    </aaa-button>
  }
  <aaa-button
    size="medium"
    variant="on-map"
    class="drr-map-button"
    i18n-aria-label
    (click)="handleViewList()"
    aria-label="View List">
    <aaa-text size="subheadline" color="primary" i18n>View List</aaa-text>
    <aaa-icon size="small" color="dark" name="list"></aaa-icon>
  </aaa-button>
</ion-row>
